import React, { useState } from 'react'
import styled from 'styled-components'
import { usePrimaryColor, colors, setPrimaryColor } from '../colors'

const ColorPicker = styled(props => {
  const [picking, setPicking] = useState(false)
  const primaryColor = usePrimaryColor()
  const otherColors = colors.filter(color => color !== primaryColor)
  return (
    <div {...props}>
      <ColorOption
        color={primaryColor}
        onClick={() => {
          if (picking) {
            setPrimaryColor(primaryColor)
            setPicking(false)
          } else setPicking(true)
        }}
      />
      {picking && otherColors.map(color =>
        <ColorOption
          key={color}
          color={color}
          onClick={() => {
            setPrimaryColor(color)
            setPicking(false)
          }}
        />
      )}
    </div>
  )
})`
  position: absolute;
  top: 0px;
  right: 0px;
  z-index: 100;
`
const ColorOption = styled.div`
  margin: 15px;
  height: 30px;
  width: 30px;
  border-radius: 50%;
  background-color: ${p => p.color};
  border: 2px solid white;
  cursor: pointer;
  transition: transform 0.2s;
  &:hover {
    transform: scale(1.1)
  }
`

export default ColorPicker